export enum DocType {
    Statement = 'stmt',
    Invoice = 'inv',
}
